import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 1052.362 398.337"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", {
        id: "a",
        clipPathUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("path", { d: "M0 3186.7V0h8418.9v3186.7z" })
      ])
    ], -1),
    _createElementVNode("g", {
      "clip-path": "url(#a)",
      transform: "matrix(.13 0 0 -.13 0 398.337)"
    }, [
      _createElementVNode("path", {
        d: "m860.367 1158.07 400.813 1009.72 395.16-1009.72zm2.063 2028.63 191.27-488.73L0 43.629h417.98L716.938 796.75H1797.74l294.73-753.121h850.14L1712.52 3186.7zM4101.41 1448.99h993.92l145.79 367.25H4101.41v992.03h1246.53l150.24 378.43H3305.47V43.629h2074.9l150.25 378.48H4101.41zM7151.84 1448.99h524.59V385.422c-62.78-17.203-134.63-27.352-210.74-27.313-707.17 0-914.05 655.451-914.05 1235.241 0 556.27 177.5 1214.92 861.15 1214.92h728.6l150.2 378.43h-964.34c-936.35 0-1597.24-647.04-1597.24-1593.35C5730.01 658.75 6364.78 0 7349.04 0c490.34 0 808.19 93.441 1069.86 184.738V1816.24H7297.61z",
        style: {"fill":"#d31937","fill-opacity":"1","fill-rule":"nonzero","stroke":"none"}
      })
    ], -1)
  ])))
}
export default { render: render }